<template>
  <div class="tab">
    <h1>Upload Requests</h1>
    <div class="top-right">
      <v-button
        size="small"
        type="plain"
        @click="handlerNewRequest"
      >New Request</v-button>
    </div>
    <div v-if="uploadList.length>0">
      <div
        v-for="(item,index) in uploadList"
        :key="index"
        class="upload-content">
        <div class="flex flex-sb upload-title">
          <span>
            <span class="time">{{item.created_date}}</span>
            <span class="remark">{{item.remark}} </span>
          </span>
          <span
            class="status "
            :class="{
              'warning-plain':item.stts==0,
              'active-plain':item.stts!=0,
            }"
          >
            {{item.stts_language}}
          </span>
        </div>
        <div v-if="item.stts==0">
          <div
            class="flex flex-sb">
            <ul>
              <li
                v-for="(file_item,index) in item.file"
                :key="'file'+index">{{file_item.name}}</li>
            </ul>
            <div class="flex flex-end">
              <font-awesome-icon
                icon="sms"
                class="blue"
                @click="handlerResend(item.id)"
              ></font-awesome-icon>
              <font-awesome-icon
                icon="trash-alt"
                class="del"
                @click="handlerDel(item.id,index)"></font-awesome-icon>
            </div>

          </div>
        </div>

        <div
          v-else
          class="flex flex-img">
          <div
            v-for="(file_item,index) in item.file"
            :key="'file_img'+index"
            class="img-container">
            <div class="img-content">
              <v-pdf
                v-if="isPdf(file_item.url)"
                :url="file_item.url"></v-pdf>
              <img
                v-else
                :src="file_item.url"
                alt="">
            </div>
            <div class="flex flex-sb">
              <p
                v-tooltip="file_item.name"
                class="hand">{{file_item.name}} </p>
              <font-awesome-icon
                icon="download"
                class="blue"
                @click="handlerDown(file_item.url)"></font-awesome-icon>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div
      v-else
      align="center"
      class="algin-center">
      <span>No Data</span>
    </div>
    <upload-request-dialog
      ref="requestDialog"
      :form="form"
      :customerData="customerId"
      @upList="handlerUpList">
    </upload-request-dialog>
    <send-email-sms
      ref="send-email-sms"
      :form="form.customer_profile"
      :showUsername="true"
      :skip="false"
      :initContent="form.upload_request_data"
      @send="handlerSend" />
  </div>
</template>

<script>
import UploadRequestDialog from '../dialog/upload-reques-dialog'
import { getUploadRequestList,sendUploadRequest,delAccountRequest } from '@/api/account'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'uploadRequest',
  components:{
    UploadRequestDialog,
    SendEmailSms
  },
  props: {
    // customerId: [String, Number],
    // form: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  inject:['detailData','customer_id'],
  data(){
    return{
      uploadList:[],
      resend_id:''
    }
  },
  computed:{
    customerId(){
      return this.customer_id()
    },
    form(){
      return this.detailData()
    },
    isPdf() {
      return url => {
        if(String(url).toLowerCase().indexOf('.pdf') != -1) {
          return true
        }
        return false
      }

    },
  },
  created(){
    this.network().getUploadRequestList()
  },
  methods:{

    addListData(data){
      this.$emit('refresh')
      this.uploadList.unshift(data)
    },
    handlerDel(id,index){
      this.network().delAccountRequest({id})
      this.uploadList.splice(index,1)
    },
    handlerResend(id){
      this.resend_id = id
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerSend(content){
      let params = {
        id:this.resend_id,
        content
      }
      this.network().sendUploadRequest(params)
    },
    handlerUpList(){
      this.network().getUploadRequestList()
    },
    handlerNewRequest(){
      this.$refs.requestDialog.changeDialog()
    },
    handlerDown(data){
      window.open(data, '_blank')
    },
    network() {
      return {
        getUploadRequestList: async () => {
          const { data } = await getUploadRequestList({
            customer_id: this.customerId
          })
          this.uploadList = data
        },
        sendUploadRequest: async (params) => {
          const { data } = await sendUploadRequest(params)
          this.$refs['send-email-sms'].changeDialog()
        },
        delAccountRequest: async (params) => {
          const { data } = await delAccountRequest(params)
          // this.network().getUploadRequestList()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .tab {
    position: relative;
    margin-right: 45px;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
  }
  .top-right {
    position: absolute;
    top: 0;
    right: 0;
  }
    .upload-content{
      padding: 15px;
      margin-top: 20px;
      box-sizing: border-box;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      background-color: #FFFFFF;
      .warning-plain {
        border: 1px solid #B08800;
        color: #B08800;
      }
      .active-plain {
        border: 1px solid #28A745;
        color: #28A745;
      }
      .blue{
        color: #0366D6;
        font-size: 14px;
        cursor: pointer;
      }
      .del{
        color: #CB2431;
        margin-left: 15px;
        font-size: 14px;
      }
      .upload-title{
        margin-bottom: 17px;
        .remark{
          color: #586069;
          font-family: Inter;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 17px;
          margin-left: 17px;
        }
        .time{
          color: #24292E;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
        }
        .status{
          display: block;
          margin-right: 5px;
          padding: 0 10px;
          height: 24px;
          line-height: 22px;
          border-radius: 25px;
          font-size: 12px;
          white-space: nowrap;
        }
      }
      ul{
        margin-left: 15px;
        li{
          color: #586069;
          font-family: Inter;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 17px;
        }
      }
      .flex-end{
        align-self: flex-end;
      }
      .flex-img{
        /*justify-content: space-between;*/
        flex-wrap: wrap;
        .img-container{
          margin-top: 20px;
          margin-right: 20px;
          .img-content{
            width: 206.67px;
            height: 150px;
            border: 1px solid #D1D5DA;
            border-radius: 5px;
            margin-bottom: 10px;
            justify-content: center;
            align-items: center;
            display: flex;
            /*position: relative;*/
            overflow: hidden;
            img{
              display: block;
              width: 100%;
            }
          }
          .flex{
            width: 206.67px;
            p{
              width: 80%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        p{
          color: #24292E;
          font-family: Inter;
          font-size: 12px;
          letter-spacing: 0;
        }

      }
    }
    .algin-center{
      margin-top: 50px;
      color: #586069;
    }
  }
</style>
